exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideMode-error[data-v-186d3b88]{height:480px;flex-direction:column;color:#fff;background:#d4645c;font-weight:700;border-radius:3px;overflow:hidden}.slideMode-error[data-v-186d3b88],.slideMode-error_body[data-v-186d3b88]{width:100%;display:flex;align-items:center;justify-content:center}.slideMode-error_body[data-v-186d3b88]{height:430px;font-size:18px}", ""]);

// exports
